var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-font-preview",class:{'selected': _vm.selected},style:({fontFamily: _vm.fontFamily}),on:{"click":function($event){return _vm.$emit(`click`, _vm.fontFamily)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.fontFamily))]}),(_vm.selected)?_c('i',{staticClass:"fas fa-check icon-check"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }